import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedMovies from './components/FeaturedMovies';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedMovies />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '80s电影网',
            url: 'https://www.80sdyw.com/',
            description:
              '80s电影网提供高清在线看免费不卡影视资源，蓝光画质搭配极速播引擎，点开即播不缓冲。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.80sdyw.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
            inLanguage: 'zh-CN',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '80s电影网',
            url: 'https://www.80sdyw.com/',
            description: '高清在线看免费不卡影视平台',
            sameAs: [],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '80s电影网-高清在线看免费不卡 | 蓝光画质极速播',
            description:
              '80s电影网提供高清在线看免费不卡影视资源，蓝光画质搭配极速播引擎，点开即播不缓冲。',
            url: 'https://www.80sdyw.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '80s电影网',
              url: 'https://www.80sdyw.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '80s电影网的视频需要付费吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '完全不需要！80s电影网所有影视资源均为免费在线观看。无需注册、无需付费，点开即播。',
                },
              },
              {
                '@type': 'Question',
                name: '支持哪些设备观看？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '80s电影网全面支持电脑、平板、手机等各类设备。采用HTML5播放技术，无需安装任何插件。',
                },
              },
              {
                '@type': 'Question',
                name: '视频画质怎么样？会卡顿吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们提供蓝光高清画质，最高支持4K分辨率。采用先进的CDN加速和极速播引擎技术，确保播放流畅。',
                },
              },
              {
                '@type': 'Question',
                name: '每天什么时候更新新内容？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们的内容团队全天候工作，每日分多个时段更新。热门电影、电视剧会在上线后第一时间收录。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}